export const APP_URL = "https://localhost:3000/"


// Env vars
export const GSP_ENV = "www";
export const AM_URL = `https://${GSP_ENV}.security.online-banking.sabbnet.com/am`;

// export const AM_URL = `https://uatgkeusrin01drnt0.systems.sa.hsbc/am`;

// export const CS_SDK_URL = "https://app-cs-prod.sab.com/in/web-sdk/v1/static/web-sdk.js"
export const CS_URL = "https://app-cs-prod.sab.com"
// export const CS_URL = "https://app-cs-uat.sab.com"


export const CS_LOCAL_URL = "fonts/web-sdk.js"

// Yes, the debugger boolean is intentionally reversed
// export const DEBUGGER = process.env.DEBUGGER_OFF_ENV === 'true' ? false : true;

export const DEBUGGER = false;
export const ERRORBOUND = true;
//export const JOURNEY_LOGIN = "userLogin";
export const JOURNEY_LOGIN = "ex_v2_sabnetUserLogin";
export const REALM_PATH = "external";
export const SESSION_URL = `${AM_URL}json/realms/root/sessions`;
export const USERNAME_COOKIE = "username";

// Images
export const INFO_ICON = "icon-informative-xlarge.png"
export const DASHBOARD_URL = `https://${GSP_ENV}.services.online-banking.sabbnet.com/gpib/group/gpib/cmn/layouts/default.html?uid=dashboard`


// Colors
export const kPrimaryColor = "#D22630"


// Timers
export const API_TIMEOUT = 30000;
export const FR_API_TIMEOUT = 30000;